/**
 * Strip the `data:<mime>;base64,` prefix a FileReader data URL starts with.
 *
 * Any MIME type: the old pattern allowed only letters, so `image/svg+xml`
 * and `application/octet-stream` (what a file with no type reads as) kept
 * their prefix and went out as corrupt base64.
 */
const trimBase64Text = (text) => text.replace(/^data:[^;,]*;base64,/, '')

export default trimBase64Text
